import React from 'react';

import styled from 'styled-components';
import { Button } from 'styles/admin';
import { StyledBox, StyledTooltip } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

const SidepanelFooter = ({
  onSave,
  onCancel,
  loading,
  disabled,
  primaryActionText,
  showPrimaryAction = true,
  secondaryActionText,
  leftComponent = null,
  containerHeight = 'auto',
  buttonHeight = '5ch',
  width = '40%',
  position = 'fixed',
  tooltip = '',
  showTooltip = false, // for a use-case where we want to show tooltip on not disabled
  bgColor = getColorFromKey('white'),
}) => (
  <Container width={width} position={position} bgColor={bgColor}>
    <StyledBox flexcontainer>{leftComponent || null}</StyledBox>
    <StyledBox flexcontainer height={containerHeight}>
      {onCancel && (
        <StyledButton
          blueOutline
          size="large"
          onClick={onCancel}
          disabled={loading}
          style={{ width: '160px' }}
          height={buttonHeight}
        >
          {secondaryActionText || 'Cancel'}
        </StyledButton>
      )}
      {showPrimaryAction && (
        <>
          {onSave && (
            <StyledTooltip title={disabled || showTooltip ? tooltip : ''}>
              <span>
                <StyledButton
                  blue
                  size="large"
                  onClick={onSave}
                  disabled={loading || disabled}
                  style={{ marginLeft: onSave && onCancel ? '1rem' : '0', width: '160px' }}
                  height={buttonHeight}
                >
                  {primaryActionText || 'Save'}
                </StyledButton>
              </span>
            </StyledTooltip>
          )}
        </>
      )}
    </StyledBox>
  </Container>
);

const Container = styled.div`
  width: ${(props) => props.width};
  position: ${(props) => props.position};
  bottom: 0;
  right: 0;
  border-top: 1px solid #eaeaea;
  padding: 0.7rem 2rem;
  background: ${(props) => props.bgColor};
  display: flex;
  justify-content: space-between;
  min-height: 3rem;
  height: 8vh;
  align-items: center;
`;

const StyledButton = styled(Button)`
  height: ${(props) => props.height};
`;

export default SidepanelFooter;
